import { svg } from 'lit';
import { bounds, highlightStateProvider, series } from '../types.js';
import { mapLegendData } from './mapLegendData.js';
import { Legend } from './Legend.js';
import { interpolate, svgTransition } from '../../../visualizations/common/directives/svgTransition.js';
import { timing } from '../animation.js';
import { legendEventCallbacks, legendsConfiguration } from './types.js';
import { styleMap } from 'lit/directives/style-map.js';
export function Legends({
  legendsConfiguration,
  bounds,
  series,
  animate,
  highlightStateProvider,
  onLegendMouseEnter,
  onLegendMouseLeave
}: {
  legendsConfiguration: legendsConfiguration;
  bounds: bounds;
  series: series[];
  animate: boolean;
  highlightStateProvider: highlightStateProvider;
} & legendEventCallbacks) {
  const legendData = mapLegendData(series);
  const {
    legendsOffsetTop,
    legendsOffsetLeft,
    legendsHorizontalGap,
    legendsVerticalGap
  } = legendsConfiguration;
  const width = bounds.right - bounds.left - legendsOffsetLeft;
  const height = bounds.bottom - bounds.top;
  return svg`
    <foreignObject
      class="legends"
      width=${width}
      height=${height}
      x=${bounds.left + legendsOffsetLeft}
      y=${bounds.top + legendsOffsetTop}
      ${svgTransition({
    timing: timing(animate),
    attributes: {
      opacity: interpolate.standard(0, 1, 0)
    }
  })}
    >
      <div style=${styleMap({
    display: 'flex',
    'flex-wrap': 'wrap',
    gap: `${legendsVerticalGap}px ${legendsHorizontalGap}px`
  })}>
        ${legendData.map(legend => Legend({
    legendsConfiguration,
    type: legend.type,
    color: legend.color,
    name: legend.name,
    highlightStateProvider,
    onLegendMouseEnter,
    onLegendMouseLeave
  }))}
      </div>
    </foreignObject>
  `;
}